import Mutations from '../../odata/mutations';

export default { ...new Mutations('comment'), ...new Mutations('comments'), ...new Mutations('solutionComments') };
